import useFetch from '@hooks/useFetch';

const usePracticesByEducator = ({ username }) => {
  const { data: dppResult, isValidating: isFetchingDpps } = useFetch(
    `v1/search_v3/educators/${username}/dpp_practice/?limit=6&offset=0&web_exp=true`,
    {},
    { revalidateOnMount: true }
  );
  return {
    dppResult,
    isFetchingDpps
  };
};

export default usePracticesByEducator;
